export default __webpack_public_path__ + "static/logo-orangejellyfish-eaf1f64dd76b0ff765ea0cb490f21045.svg";